import { render, staticRenderFns } from "./DropZoneV30Component.vue?vue&type=template&id=a7c8e52e&scoped=true"
import script from "./DropZoneV30Component.vue?vue&type=script&lang=js"
export * from "./DropZoneV30Component.vue?vue&type=script&lang=js"
import style0 from "./DropZoneV30Component.vue?vue&type=style&index=0&id=a7c8e52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c8e52e",
  null
  
)

export default component.exports